module.exports = __webpack_public_path__ + "static/img/newgiftbg.7fcdd27.jpg";